
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/zuora",
      function () {
        return require("private-next-pages/destinations/zuora.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/zuora"])
      });
    }
  